import type { RowDetails } from '../model/row-details';
import { Hotel, Package } from 'lucide-react';
import css from './row-detail-tooltip.module.scss';

// Class for the shared Tooltip's `bubbleClassName` so the detail table isn't
// clipped by the default 260px text cap.
export const detailTooltipBubble = css.bubble;

const ROW_LABELS: ReadonlyArray<[keyof RowDetails, string]> = [
  ['name', 'Name'],
  ['country', 'Country'],
  ['city', 'City'],
  ['streetAddress', 'Street Address'],
  ['location', 'Location'],
];

// Single-entity detail table (products / HyperGuest columns).
export const RowDetailTooltip = ({ details }: { details: RowDetails }) => (
  <table className={css.table}>
    <tbody>
      {ROW_LABELS.map(([key, label]) => (
        <tr key={key}>
          <td className={css.label}>{label}</td>
          <td className={css.value}>{details[key]}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

// Side-by-side Product vs HyperGuest comparison (Matches / Approval columns).
// Matching cells are highlighted, mirroring the legacy green-on-match table.
export const MatchDetailTooltip = ({
  product,
  hotel,
}: {
  product: RowDetails;
  hotel: RowDetails;
}) => (
  <table className={css.table}>
    <thead>
      <tr>
        <th />
        <th className={css.head}>
          <span className={css.headInner}>
            <Package className={css.headIcon} />
            Product
          </span>
        </th>
        <th className={css.head}>
          <span className={css.headInner}>
            <Hotel className={css.headIcon} />
            HyperGuest
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      {ROW_LABELS.map(([key, label]) => {
        const match = product[key] === hotel[key];
        return (
          <tr key={key}>
            <td className={css.label}>{label}</td>
            <td className={match ? css.valueMatch : css.value}>
              {product[key]}
            </td>
            <td className={match ? css.valueMatch : css.value}>{hotel[key]}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);
